import React from 'react'
import { IconButton } from '@mui/material'
import ScaleIcon from '@mui/icons-material/MonitorWeight'
import PropTypes from 'prop-types'
import { noop } from 'lodash'

const ScaleButton = ({ onClick, ...restProps }) => (
  <IconButton size="small" aria-label="camera" onClick={onClick} style={{ padding: '4px' }} {...restProps}>
    <ScaleIcon />
  </IconButton>
)

ScaleButton.propTypes = {
  onClick: PropTypes.func,
}

ScaleButton.defaultProps = {
  onClick: noop,
}

export default ScaleButton
